'use strict';

import {combineReducers} from "redux";
import AlertsReducer from "./Reducers/AlertsReducer";

export default combineReducers({
    'main': AlertsReducer
});